import { useRunChecklistStore } from '@/stores/run/run-checklist.store';
import { Run } from '@/types/run.type';
import { useEffect } from 'react';
import { shallow } from 'zustand/shallow';
import RunBuilderMenuComponent from './run-builder-menu.component';
import { RunChecklistTree } from './run-by-id.component';
import ClassicViewRunBuilderComponent from './views/classic-view/classic-view-run-builder.component';
import { RunProgressComponent } from './run-progress.component';

interface RunBuilderComponentProps {
  runCompleted: boolean;
  runObject: Run;
  runChecklistTree: RunChecklistTree | undefined;
}

export default function RunBuilderComponent({
  runCompleted,
  runObject,
  runChecklistTree
}: RunBuilderComponentProps) {
  // Variables

  // Store
  const [setRunChecklistObject, setRunChecklistTree, isPreview, isPublic] =
    useRunChecklistStore(
      s => [
        s.setRunChecklistObject,
        s.setRunChecklistTree,
        s.isPreview,
        s.isPublic
      ],
      shallow
    );

  useEffect(() => {
    if (runObject && runChecklistTree) {
      setRunChecklistObject(runObject);
      setRunChecklistTree(runChecklistTree);
    }
  }, [runObject, runChecklistTree, setRunChecklistObject, setRunChecklistTree]);

  return (
    <>
      <div className="relative w-full h-full">
        {/* 1) Fixed progress bar at top */}
        {!isPreview && !isPublic && (
          <div className="fixed top-0 left-0 right-0 z-50">
            <RunProgressComponent />
          </div>
        )}

        {/* 2) Push all content down by the height of the bar (h-1 = 0.25rem) */}
        <div className="pt-1 h-full w-full flex flex-col">
          {/* Menu */}
          {!isPreview && !isPublic && (
            <div className="">
              <RunBuilderMenuComponent title={runObject.name || ''} />
            </div>
          )}

          {/* Body */}
          <div className="flex-1 cl_primary_background">
            <ClassicViewRunBuilderComponent runCompleted={runCompleted} />
          </div>
        </div>
      </div>
    </>
  );
}
